import React, {useCallback, useEffect} from 'react';
import VideoPlayer from '../../components/player/VideoPlayer';
import OnlineChatPanel from '../../components/ballroom/OnlineChatPanel';
import QnAPanel from '../../components/ballroom/QnAPanel';
import {useHistory, useLocation} from 'react-router-dom';
import AwardPanel from '../../components/ballroom/AwardPanel';
import {FrontendRoutes} from '../../constants';
import {useCollectionData} from 'react-firebase-hooks/firestore';
import {awardWinnersRef, ballRoomSettings} from '../../config/firebaseConfig';
import BallroomModal from './BallroomModal';
import NavButtons from './NavButtons';
import CustomHistory from "../../CustomHistory";
import testVideo from "../../assets/test_video.mp4"

export const VideoTypes = {
	WELCOME: 'welcome',
	PANEL: 'panel',
	AWARD: 'award'
};


export const TimeMarks = {
	'1': 12,
	'2': 512,
	'3': 1012,
	'4': 1500
};

function getWinnerNumberBasedOnTime(time) {
	return Object.keys(TimeMarks).reverse().find(k => time >= TimeMarks[k]) || '1';
}

function getTime(videoType) {
	switch (videoType) {
		case VideoTypes.WELCOME:
			return 0;
		case VideoTypes.PANEL:
			return 50;
		case VideoTypes.AWARD:
			return 100;
		default:
			return 0;
	}
}

function BallroomPage(props) {
	const history = useHistory();
	const location = useLocation();
	const params = new URLSearchParams(location.search);
	const videoType = params.get('type');
	const startFrom = params.get('startFrom');
	
	const [isLive, setIsLive] = React.useState(true);
	const [BallRoomSetting] = useCollectionData(ballRoomSettings);
	// const [videoTime, setVideoTime] = React.useState(0)
	const [activeWinner, setActiveWinner] = React.useState(0);
	const [winners] = useCollectionData(awardWinnersRef, {idField: 'number'});
	const [width, setWidth] = React.useState(window.innerWidth * 0.6);
	const [fontSize, setFontSize] = React.useState(window.innerWidth > 900 ? 36 : window.innerWidth * 0.02);
	const [modalIsOpen, setModalOpen] = React.useState(false);
	const [seek, setSeekTo] = React.useState(0);
	
	const handleModalClose = useCallback(() => {
		setModalOpen(false);
	}, []);
	
	const handleModalOKClick = useCallback(() => {
		setModalOpen(false);
	}, []);
	
	useEffect(() => {
		if (BallRoomSetting && BallRoomSetting.length) {
			setIsLive(BallRoomSetting[0].isLive);
			if (BallRoomSetting[0].isLive) {
				history.push(FrontendRoutes.BALLROOM(BallRoomSetting[0].roomType));
			}
			if (BallRoomSetting[0].roomType === VideoTypes.AWARD || BallRoomSetting[0].roomType === VideoTypes.PANEL) {
				setModalOpen(false);
			}
		}
		
		function handleResize() {
			setWidth(window.innerWidth * 0.6);
			if (window.innerWidth > 900)
				setFontSize(window.innerWidth * 0.02);
			else
				setFontSize(window.innerWidth * 0.01);
		}
		
		window.addEventListener('resize', handleResize);
	}, [BallRoomSetting]);
	
	
	useEffect(() => {
		if (!isLive && !startFrom)
			setSeekTo(getTime(videoType));
	}, [videoType, startFrom, isLive]);
	
	const onHandlePlay = () => {
	
	};
	const onHandleStop = () => {
	
	};
	const onHandleSetTime = (time) => {
		onHandleProgress({playedSeconds: time});
	};
	
	const onHandleProgress = useCallback((progress) => {
		if (progress.playedSeconds < 1 && videoType !== VideoTypes.WELCOME) {
			history.push(FrontendRoutes.BALLROOM(VideoTypes.WELCOME));
		}
		if (progress.playedSeconds >= 50 && progress.playedSeconds < 100 && videoType !== VideoTypes.PANEL) {
			history.push(FrontendRoutes.BALLROOM(VideoTypes.PANEL, progress.playedSeconds));
		} else if (progress.playedSeconds >= 100 && progress.playedSeconds < 350 &&
			(videoType !== VideoTypes.AWARD || activeWinner !== 1)) {
			history.push(FrontendRoutes.BALLROOM(VideoTypes.AWARD, progress.playedSeconds));
			setActiveWinner(1);
		} else if (progress.playedSeconds >= 350 && (videoType !== VideoTypes.AWARD || activeWinner !== 2)) {
			history.push(FrontendRoutes.BALLROOM(VideoTypes.AWARD, progress.playedSeconds));
			setActiveWinner(2);
		}
	}, [winners, activeWinner, videoType, history]);
	
	console.log(activeWinner, winners);
	
	const winnersInfo = winners ? winners.find(w => w.number === '' + activeWinner) : null;
	
	return (
		<div id="bg" className="ballroom" style={{marginTop: '1.1vw'}}>
			<div style={{margin: '2% 20vw 8vw', height: width * 0.5}}>
				<div style={{display: 'flex'}}>
					<VideoPlayer
						videoType={videoType}
						islive={isLive}
						videoSource={testVideo}
						handlePlay={onHandlePlay}
						handleStop={onHandleStop}
						handleSetTime={onHandleSetTime}
						handleOnProgress={onHandleProgress}
						seek={seek}
					/>
					<div className={'ballroom-chat-qa'}>
						{videoType === VideoTypes.PANEL &&
						<QnAPanel
							height={window.innerWidth > 900 ? width * 0.5 * 0.38 : window.innerHeight * 0.1} {...props}
							islive={isLive}
						/>}
						{(videoType === VideoTypes.WELCOME) &&
						<OnlineChatPanel
							height={window.innerWidth > 900 ? width * 0.5 * 0.38 : window.innerHeight * 0.1} {...props}
							islive={isLive}
						/>}
						{videoType === VideoTypes.AWARD && winnersInfo &&
						<AwardPanel winner={winnersInfo}
						            height={window.innerWidth > 900 ? width * 0.5 * 0.38 : window.innerHeight * 0.1}/>}
					</div>
				</div>
				{!isLive && <NavButtons videoType={videoType}/>}
			</div>
			<BallroomModal open={modalIsOpen}
			               onClose={handleModalClose}
			               onOk={handleModalOKClick}
			               videoType={videoType}/>
		</div>
	);
}
export default BallroomPage;
